enum EmailTemplateType {
  AppointmentConfirmation = "AppointmentConfirmation",
  OrderAssignmentNotice = "OrderAssignmentNotice",
  TechnicianEnRouteNotice = "TechnicianEnRouteNotice",
  CloseoutAndCompletionNotice = "CloseoutAndCompletionNotice",
  OrderSand = "OrderSand",
  Approved = "Approved",
  NonResponse = "NonResponse",
  TrimDayOne = "TrimDayOne",
  TrimDayTwo = "TrimDayTwo",
  TopOutDayOne = "TopOutDayOne",
  TopOutDayTwo = "TopOutDayTwo",
  RoughCathedralSandDayOne = "RoughCathedralSandDayOne",
  RoughCathedralSandDayTwo = "RoughCathedralSandDayTwo",
  RoughBuilderSandDayOne = "RoughBuilderSandDayOne",
  RoughBuilderSandDayTwo = "RoughBuilderSandDayTwo",
  UpdateOrder = "UpdateOrder",
}

export { EmailTemplateType };
